
import Vue from 'vue';

interface Environment {
  name: string;
  displayName: string;
  isProduction: boolean;
}

export default Vue.extend({
  name: 'EnvironmentIndicator',
  data() {
    return {
      isElectron: false,
      currentEnvironment: null as Environment | null
    };
  },
  computed: {
    environmentClass(): string {
      if (!this.currentEnvironment) return '';
      
      switch (this.currentEnvironment.name) {
        case 'production':
          return 'env-production';
        case 'staging':
          return 'env-staging';
        case 'development':
          return 'env-development';
        case 'localhost':
          return 'env-localhost';
        default:
          return 'env-unknown';
      }
    }
  },
  mounted() {
    this.loadEnvironment();
  },
  methods: {
    async loadEnvironment() {
      if ('electron' in window && (window as any).electron) {
        this.isElectron = true;
        try {
          const env = await (window as any).electron.invoke('environment:get-current');
          this.currentEnvironment = env;
        } catch (error) {
          console.error('Failed to load environment:', error);
        }
      }
    }
  }
});
